import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  centerCost: [],
  centerCostLength: 0,
  centerCostError: "",
  formErrors: "",
}

export default function centerCostReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOAGIND_COST_CENTER:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_COST_CENTER:
      return {...state, saveLoader: action.payload}
    case actions.GET_COST_CENTER:
      return {...state, centerCost: action.payload.centerCost, centerCostLength: action.payload.centerCostLength}
    case actions.FORM_FAIL:
      return { ...state, formErrors: action.payload };
    case actions.COST_CENTER_FAIL:
      return { ...state, centerCostError: action.payload };
    default:
      return state
  }
}




